export const SELECTOR_FULFILLMENT_SELECTED = (state) =>
  state.fulfillments.fulfillmentSelected;

export const SELECTOR_FULFILLMENT_CURRENT = (state) =>
  state.fulfillments.fulfillments[state.fulfillments.fulfillmentSelected];

export const SELECTOR_FULFILLMENTS = (state) =>
  Object.values(state.fulfillments.fulfillments);
